import {v4 as uuidv4} from 'uuid'


class NavObj {
    constructor(title, icon, link, bottom = false) {
        this.title = title;
        this.icon = icon;
        this.to = link;
        this.bottom = bottom;
    }
}

class TaskObj {
    constructor(title, notes, isCompleted = false) {
        this.id = uuidv4();
        this.title = title;
        this.notes=  notes;
        this.isCompleted = isCompleted;
    }
}

export {
    NavObj, TaskObj
};